export const FETCH_TEAM_DETAILS = 'FETCH_TEAM_DETAILS';
export const FETCH_TEAM_DETAILS_SUCCESS = 'FETCH_TEAM_DETAILS_SUCCESS';
export const FETCH_TEAM_DETAILS_FAIL = 'FETCH_TEAM_DETAILS_FAIL';
